import { localize } from '../i18n';
// Native/store error text is diagnostic data, never user-facing copy.
export function purchaseFailureMessage(result) {
    if (result.status === 'not_found') {
        return localize("구매 내역을 찾지 못했어요.\n구매할 때 사용한 Apple 또는 Google 계정으로 스토어에 로그인한 뒤 구매 복원하기를 눌러주세요.");
    }
    const detail = String(result.message || '').toLowerCase();
    const restoreHint = localize('\n이미 결제했다면 다시 구매하지 않고 구매 복원하기를 눌러주세요.');
    if (result.code === 'PURCHASE_VERIFICATION_UNAVAILABLE' || /구매 확인이 늦어지고 있어요/.test(detail)) {
        return localize("구매 확인이 늦어지고 있어요. 잠시 후 다시 확인해주세요.") + restoreHint;
    }
    if (/업데이트/.test(detail)) return localize("현재 앱에서 구매를 진행하기 어려워요.\n스토어에서 앱을 최신 버전으로 업데이트한 뒤 다시 시도해주세요.") + restoreHint;
    if (/network|timeout|네트워크|인터넷/.test(detail)) {
        return localize("구매 정보를 확인하지 못했어요.\n인터넷 연결을 확인한 뒤 다시 시도해주세요.") + restoreHint;
    }
    if (/상품|product|스토어 연결|billing/.test(detail)) {
        return localize("스토어에서 구매 정보를 불러오지 못했어요.\n잠시 후 다시 시도해주세요.") + restoreHint;
    }
    return (result.restored ? localize("구매 내역을 복원하지 못했어요.") : localize("광고 제거 적용을 확인하지 못했어요."))
        + localize("\n잠시 후 다시 시도해주세요.") + restoreHint;
}
